/**
 * @name MBadgesTypes
 * @description
 * Enum defining the available badge styles used by `MBadgeDirective`.
 * These types control the visual appearance and behavior of the badge.
 *
 * @enum
 * @export
 */
export enum MBadgesTypes {
  /**
   * Badge displayed at the top-right corner, usually for relay-type indicators.
   */
  RELAIS_TOP = 'relais--top',

  /**
   * Badge displayed at the bottom-right corner, typically for secondary relay indicators.
   */
  RELAIS_BOTTOM = 'relais--bottom',

  /**
   * Badge used to indicate service disturbances or alerts.
   */
  DISTURBANCES = 'disturbances',

  /**
   * Badge that displays a numeric value (e.g., number of items or notifications).
   */
  NUMBER = 'number',

  /**
   * Minimalist dot-style badge, used for subtle indicators.
   */
  MINIMAL = 'minimal',

  /**
   * Badge indicating an HS (Hors Service / Out of Service) state.
   */
  HS = 'hs',
}

export enum MBadgesPosition {
  OUTSIDE = 'outside',
  INSIDE = 'inside',
}
